export enum FaDirectiveEnum {
  FAS = 'fas',
  FAR = 'far',
  FAB = 'fab',
}
